import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'
import {ForYouSectionError} from './ForYouSectionFallbacks'
import {MiniOverviewMergeStatus} from './mergeability/MiniOverviewMergeStatus'
import {ForYouNextAction} from './ForYouNextAction'
import styles from './shared/ForYouSubSection.module.css'

export function ForYouSection() {
  return (
    <ErrorBoundary boundaryName="CondensedForYouSection" fallback={<ForYouSectionError />}>
      <Suspense fallback={null}>
        <div className={styles.CondensedForYouContainer}>
          <ForYouNextAction />
          <MiniOverviewMergeStatus />
        </div>
      </Suspense>
    </ErrorBoundary>
  )
}
